import { LodashHelper } from ".";

export class DraftHelper {
  constructor(rider) {
    this.rider = rider;
  }

  //This method only used when we create rider while creating the ride request. Every rider that is created on the process of creating ride should be editable on creating ride process
  static updateStepOneDraftForNewRider(values) {
    const riderDraft = {};
    const riderInfo = values?.riderInfo || {};

    if (values?.riderDraft?.id || riderInfo?.id) {
      riderDraft.id = riderInfo?.id || values?.riderDraft?.id;
    }
    riderDraft.firstName = riderInfo?.firstName;
    riderDraft.lastName = riderInfo?.lastName;
    riderDraft.canPhoneReceiveCalls = riderInfo?.canPhoneReceiveCalls;
    riderDraft.canPhoneReceiveTexts = riderInfo?.canPhoneReceiveTexts;
    riderDraft.communicationPreferences =
      riderInfo?.communicationPreferences;
    riderDraft.patientUniqueId = riderInfo?.patientUniqueId;
    riderDraft.phoneNumber = riderInfo?.phoneNumber;
    riderDraft.dob = riderInfo?.dob;
    riderDraft.email = riderInfo?.email;
    riderDraft.preferredLanguage = riderInfo?.preferredLanguage;

    return riderDraft;
  }
  
  static getFirstStepDraftValues(values, usedExistingRider) {
    return LodashHelper.removeEmptyAndTrim({
      covid19Relation: values?.covid19Relation,
      caregivers: values?.caregivers,
      willBeCaregiverOnScene: values?.willBeCaregiverOnScene,
      riderInfo: usedExistingRider ? values?.riderInfo?.id : "",
      organizationId: values?.organizationId,
      riderDraft: values?.riderDraft === undefined ? values?.riderInfo
        : this.updateStepOneDraftForNewRider(values),
    });
  }

  static prepareDraftForSaving = (draft) => {
    const isUberRide = draft?.step2?.vehicleType === 'uberAmbulatoryRide';
    const isUberRoundTrip = isUberRide && draft?.step3?.isRoundtrip;

    let step4 = draft?.step4;
    if (isUberRoundTrip && step4) {
      const { rideNotes: _removed, ...step4WithoutCombinedNotes } = step4;
      step4 = {
        ...step4WithoutCombinedNotes,
        driverNotesLegA: step4.driverNotesLegA,
        driverNotesLegB: step4.driverNotesLegB,
      };
    }

    return LodashHelper.removeEmptyAndTrim({
      ...draft,
      ...(step4 ? { step4 } : {}),
      step1: this.getFirstStepDraftValues(
        draft?.step1,
        draft?.step1?.riderInfo?.id || draft?.step1?.riderDraft?.id
      ),
      isUberRide,
    });
  };
}
